import { connect } from 'react-redux';
import CatatPrestasi from '../../../views/Student/displiner/CatatPrestasi.student.view';
import {
  getClasses, getParamOptions, getSubjectOptions, getParamOptionsAcademics, getAchievementOptions, getPeriodsOptions, getStudentOptions, getClassesOptions, getPrmLevels, getStudentPeriodOptions,
} from '../../../states/thunks/options.thunk';
import {
  getAchievement, saveAchievement, listAchievement, editAchievement,
} from '../../../states/thunks/academics.thunk';


function mapStateToProps(state) {
  return {
    user: state.user,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getAchievementOptions: payload => dispatch(getAchievementOptions(payload)),
    handleGetClasses: payload => dispatch(getClasses(payload)),
    getSubjectOptions: payload => dispatch(getSubjectOptions(payload)),
    getParamOptions: (payload, type) => dispatch(getParamOptions(payload, type)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleGetAchievement: payload => dispatch(getAchievement(payload)),
    handleSaveAchievement: (payload, goBack) => dispatch(saveAchievement(payload, goBack)),
    handleListAchievement: (payload, goBack) => dispatch(listAchievement(payload, goBack)),
    handleEditAchievement: (payload, goBack) => dispatch(editAchievement(payload, goBack)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    getStudentOptions: payload => dispatch(getStudentOptions(payload)),
    getClassesOptions: payload => dispatch(getClassesOptions(payload)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    getStudentPeriodOptions: payload => dispatch(getStudentPeriodOptions(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CatatPrestasi);
